import React from 'react'
import { Typography, Box, withStyles } from '@material-ui/core'
import styles from './styles'

const LoadingView = ({ classes }) => {
  return (
    <div className={classes.loadingContainer}>
      <img
        src="/assets/new_mascot_noline_1.gif"
        height={200}
        style={{ margin: '0 auto' }}
      />
      <Box m={0.5} />
      <Typography
        fontSize="18px"
        fontWeight={500}
        className={classes.loadingTitle}
      >
        Generating Your Quiz with AI…
      </Typography>
      <Typography
        fontSize="14px"
        fontWeight={400}
        className={classes.loadingSubtitle}
      >
        Sit tight! We're using AI magic to generate the best quiz for you. The
        window will close automatically when it's ready. 🚀
      </Typography>
    </div>
  )
}

export default withStyles(styles)(LoadingView)
